module.exports = __webpack_public_path__ + "static/media/jcb.8638a0a8.svg";